import { type Component, onCleanup, onMount } from 'solid-js'
import { type AnimationItem } from 'lottie-web'
import lottie from 'lottie-web/build/player/lottie_light'

export interface LottieAnimationProps {
  readonly animationData: object
  readonly width?: string
}

const LottieAnimation: Component<LottieAnimationProps> = (props) => {
  let animationContainer: HTMLDivElement | undefined
  let animationInstance: AnimationItem | null = null

  onMount(() => {
    if (animationContainer) {
      if (props.width) {
        animationContainer.style.width = props.width
      }

      animationInstance = lottie.loadAnimation({
        container: animationContainer,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: props.animationData
      })
    }
  })

  onCleanup(() => {
    animationInstance?.destroy()
  })

  return (
    <div ref={animationContainer}></div>
  )
}

export default LottieAnimation
